<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>New Origin</h2>
        </div>
        <div slot="body">
            <div class="col-sm-12 py-3">
                <origins-form :origin="tempOrigin"></origins-form>
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="close">Cancel</button>
            <button type="button" class="btn wider mr-3" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal'
    import originsForm from './originsForm'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data: function() {
            return {
                tempOrigin: null
            }
        },
        created: function() {
            this.tempOrigin = JSON.parse(JSON.stringify(this.getDefaultOrigin)) // TODO: create it in store
        },
        computed: {
            ...mapGetters([
                'getDefaultOrigin' // TODO: create it in store
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'createOrigin' // TODO: create it in store
            ]),
            save: function() {
                this.createOrigin(this.tempOrigin).then( // TODO: create it in store
                    this.close()
                )
            },
            close: function() {
                this.closeModal();
            },
        },
        components: {
            Modal,
            originsForm
        }
    }
</script>

<style lang="scss" scoped>
    .langPicker{
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// createOrigin.vue?4847ba8b